import { useEffect, useCallback } from 'react';
import * as fetcher from '@hydra/utils/fetcher';
import settings from '@hydra/utils/settings';

const recaptchaSiteKey = settings.get('recaptchaSiteKey');

const useRecaptchaV3 = (context, loadScriptByDefault = true) => {
  const loadScript = useCallback((callback = null) => {
    const id = 'recaptcha-key';
    const url = `https://www.google.com/recaptcha/api.js?render=${recaptchaSiteKey}`;
    const isScriptExist = document.getElementById(id);
    if (!isScriptExist) {
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = url;
      script.id = id;
      script.onload = function () {
        if (callback) callback();
      };
      document.body.appendChild(script);
    }
    if (isScriptExist && callback) callback();
  }, []);

  useEffect(() => {
    if (loadScriptByDefault) {
      loadScript();
    }
    return () => {
      const script = document.getElementById('recaptcha-key');
      script.parentNode.removeChild(script);
    };
  }, [loadScriptByDefault, loadScript]);

  const getCaptchaScore = useCallback(async (token) => {
    try {
      const json = {
        token,
        context
      };
      const response = await fetcher.post('/api/recaptcha-score', { json }).json();
      return response.score;
    } catch (error) {
      return null;
    }
  }, [context]);

  const verifyCaptcha = useCallback(async () => {
    const token = await window.grecaptcha.execute(recaptchaSiteKey, { action: 'validate_recaptcha' });
    await getCaptchaScore(token);
  }, [getCaptchaScore]);

  const monitorCaptchaScore = useCallback(() => {
    window.grecaptcha.ready(async () => {
      await verifyCaptcha();
    });
  }, [verifyCaptcha]);

  return {
    loadScript,
    verifyCaptcha,
    monitorCaptchaScore
  };
};

export default useRecaptchaV3;
